import { ReactElement } from "react";

import CollapsibleDrawer from "~frontend/components/CollapsibleDrawer";
import { TwoColumnDisplay } from "~frontend/components/TwoColumnDisplay";
import {
  mapNameAndValueFromCampaignMetadata,
  NO_VALUE,
} from "~frontend/components/campaignMetadata/common";
import { CampaignForView } from "~frontend/routes/subaccounts/campaignView/types";

export function MetadataValuesDetails(campaign: {
  campaign: CampaignForView;
}): ReactElement {
  const { metadata } = campaign.campaign;
  const namesAndValues = metadata.map(mapNameAndValueFromCampaignMetadata);

  const twoColumnRows = namesAndValues
    .filter(v => v.value !== NO_VALUE)
    .map(({ name, value }) => ({
      key: name,
      label: name,
      content: value,
    }));

  if (twoColumnRows.length === 0) {
    return <></>;
  }

  return (
    <CollapsibleDrawer
      title="Campaign Metadata"
      startOpen={false}
      variant="slim"
      sxHeader={{ justifyContent: "flex-end", alignItems: "flex-end" }}
      sxHeading={{ fontWeight: 500 }}
    >
      <TwoColumnDisplay
        labelVariant="body2Bold"
        rows={twoColumnRows}
        labelWidth={160}
        allRowSx={{ fontSize: "12px", alignItems: "flex-start" }}
      />
    </CollapsibleDrawer>
  );
}
